export type ErrorType = 'required' | 'tooltip' | 'other';

const errorTypes: ErrorType[] = ['required', 'tooltip', 'other'];

export function isErrorType(value: string): value is ErrorType {
	return errorTypes.includes(value as ErrorType);
}
export interface CellError {
	message: string;
	type: ErrorType;
}
